<template>
  <div id="home" :class="[{'overflow': showMenu || showVideo}]">
    <header>
      <div class="header-container" title="ZHUANGSHI IMMIGRATION OFFICE">
        <img class="menu" :src="showMenu?closeIcon:openIcon" alt="" @click="changeMenuState">
      </div>
    </header>
    <section>
      <div class="level-1">
        <img class="bg1" src="../../assets/images/new/bg1.png" alt="">
        <div class="l1-inner">
          <img class="ic1" src="../../assets/images/new/icon1.png" alt="">
          <p class="l1-line1">EASE YOUR</p>
          <p class="l1-line2">CHINESE LIFE.</p>
        </div>
      </div>
      <div class="split"></div>
      <div class="level-2">
        <img class="bg2" src="../../assets/images/new/bg2.png" alt="">
        <div class="l2-inner">
          <img class="logo" src="../../assets/images/content-main.png" alt="">
          <img class="arc" src="../../assets/images/new/arc-line.png" alt="">
          <p class="l2-line1">ZHUANGSHI</p>
          <p class="l2-line2">IMMIGRATION OFFICE IS</p>
          <p class="l2-line3">Founded by Zhenhai public security bureau. It located in Building 11 Binhubandao Community Zhuangshi town Zhenhai district Ningbo city.</p>
          <p class="l2-line4">OFFICER'S WECHAT ID IS 18405849172.</p>
        </div>
      </div>
      <div class="level-3">
        <img class="bg3" src="../../assets/images/new/bg3.png" alt="">
        <div class="poster">
          <img class="poster-img" src="../../assets/images/new/poster.png" alt="">
          <img class="play" src="../../assets/images/new/play.png" alt="" @click="changeShowVideo">
        </div>
        <div class="l3-line">
          <p class="l3-line1">OFFICER YANG:</p>
          <p class="l3-line2">AN ORDINARY DAY</p>
        </div>
      </div>
      <div class="level-4">
        <img class="content" src="../../assets/images/new/content.png" alt="">
        <Menu class="menu-container" :dataList="menuList" :showText="false"/>
      </div>
      <Menu :class="['menu-container', 'menu-in', { 'show': showMenu }]" :dataList="menuList" :showText="true" style="top: 80px"/>
    </section>
    <footer>
      <div class="footer-level-1">
        <div class="l1"><img src="../../assets/images/logo.png" alt=""></div>
        <div class="l3">
          <p>Copyright ©2022- 2025 版权所有：宁波镇海庄市派出所 <br> 未经许可任何单位和个人不得在任何媒体上擅自转载和引用本网站内容</p>
        </div>
      </div>
    </footer>
    <VideoPlay v-if="showVideo"/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { getIcons } from '../../api';
  import Menu from './menu.vue';
  import VideoPlay from './videoPlay.vue';
  export default {
    name: 'HomePage',
    components: {
      Menu,
      VideoPlay,
    },
    data() {
      return {
        openIcon: require('../../assets/images/menu.png'),
        closeIcon: require('../../assets/images/close.png'),
        menuList: [
          // { id: 1, image_url: require('../../assets/list/icon_1.png'), link:'http://control.jokerhu.com/apply' },
          // { id: 2, image_url: require('../../assets/list/icon_2.png'), link:'/dogCert' },
          // { id: 3, image_url: require('../../assets/list/icon_3.png'), link:'/contradiction' },
          // { id: 4, image_url: require('../../assets/list/icon_4.png'), link:'/' },
          // { id: 5, image_url: require('../../assets/list/icon_5.png'), link:'/' },
          // { id: 6, image_url: require('../../assets/list/icon_6.png'), link:'/nucleicAcid' },
          // { id: 7, image_url: require('../../assets/list/icon_7.png'), link:'/' },
          // { id: 8, image_url: require('../../assets/list/icon_8.png'), link:'/' },
        ]
      }
    },
    computed: {
      ...mapGetters({
        showMenu: 'getShowMenu',
        showVideo: 'getShowVideo',
      })
    },
    methods: {
      changeMenuState() {
         this.$store.commit('mutation_showMenu', !this.showMenu)
      },
      changeShowVideo() {
         this.$store.commit('mutation_showVideo', !this.showVideo)
      },
      toPage(path) {
        if (path.indexOf('http') > -1) {
          window.location.href = path;
        } else {
          this.$router.push({ path });
        }
      },
      /**
        * 根据地图类型、位置获取不同的地图页面跳转链接
        * @param {*} mapType 地图类型
        * @param {*} location 经纬度 lat:纬度 lng:经度
        * @param {*} address 详细地址
        */
      getMapApp(mapType, location, address) {
          const { lat, lng } = location;
          let url = '';
          switch(mapType) {
              case '腾讯地图':
                  url = 'https://apis.map.qq.com/uri/v1/marker?marker=coord:' + lat + ',' +  lng +';addr:'+ address +';title:地址&referer=keyfree';
                  break;
              case '高德地图':
                  url = 'https://uri.amap.com/marker?position='+ lng + ',' + lat +'&name='+ address +'&callnative=1';
                  break;
              case '百度地图':
                  url = 'http://api.map.baidu.com/marker?location=' + lat + ',' +  lng +'&title=地址&content='+ address +'&output=html&src=webapp.reformer.appname&coord_type=gcj02';
                  break;
              default:
                  break;
          }
          return url;
      },
      toMap() {
        // window.location.href = 'iosamap://path?sourceApplication=applicationName&sid=BGVIS1&slat=39.92848272&slon=116.39560823&sname=A&did=BGVIS2&dlat=39.98848272&dlon=116.47560823&dname=B&dev=0&t=0';
        window.location.href = 'https://uri.amap.com/marker?position=116.39560823,39.92848272&name=AAA&callnative=1&lang=en';
      },
      // 该方法在 methods 中定义，在获取到数据后调用，index 为组件中绑定的动态 id；url 为视频地址
      initVideo() {
        this.$nextTick(() => {
          let myPlayer = this.$video(document.getElementById('my-video'), {
            controls: true,
            //自动播放属性,muted:静音播放
            autoplay: false,
            //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
            preload: "auto",
            //设置视频播放器的显示宽度（以像素为单位）
            // width: "800px",
            //设置视频播放器的显示高度（以像素为单位）
            // height: "400px",
            playbackRates: [0.5, 1, 1.5, 2, 3, 4],// 倍速播放
            controlBar: {
              playToggle:true
            },
          });
          myPlayer.src('https://wystatic.jokerhu.com/video/output.mp4'); // 重新初始化URL
          // myPlayer.load(url); //重新加载
        })
      },
      initVideo2() {
        this.$nextTick(() => {
          let myPlayer = this.$video(document.getElementById('my-video'), {
            controls: true, // 是否显示控制条
            // poster: 'xxx', // 视频封面图地址
            preload: 'auto',
            autoplay: false,
            fluid: true, // 自适应宽高
            language: 'zh-CN', // 设置语言
            muted: false, // 是否静音
            inactivityTimeout: false,
            // playbackRates: [0.5, 1, 1.5, 2, 3],// 倍速播放
            controlBar: {
              // 自定义按钮的位置
              children: [
                {name: 'playToggle'}, // 播放按钮
                {name: 'currentTimeDisplay'}, // 当前已播放时间
                {name: 'progressControl'}, // 播放进度条
                {name: 'durationDisplay'}, // 总时间
                // { // 倍数播放
                //   name: 'playbackRateMenuButton',
                //   'playbackRates': [0.5, 1, 1.5, 2, 2.5]
                // },
                {
                  name: 'volumePanel', // 音量控制
                  inline: false, // 不使用水平方式
                },
                {
                  name: "pictureInPictureToggle" //画中画播放模式
                },
                {name: 'FullscreenToggle'}, // 全屏
              ]
            },
          });
          myPlayer.src('https://wystatic.jokerhu.com/video/output.mp4'); // 重新初始化URL
          // myPlayer.load(url); //重新加载
        })
      },
      async getIcons() {
        const res = await getIcons()
        console.log('getIcons', res.data.results)
        this.menuList = [...res.data.results]
      }
    },
    beforeMount() {
      this.getIcons()
    },
    mounted() {
      // this.initVideo2();
    }
  }
</script>

<style lang="less" scoped>
@import './index.less';
</style>